import type { UserCommunication } from '@this+that/models';

import { resolveDraftCommunication } from '../../../../../utils/userCommunicationHelpers';

// FE-only: the version the provider returned for the save that produced this row.
export interface DraftVersionField {
  draftVersion?: string;
}

// Our own confirmed save wins over messageId, which a local upsert keeps from before that save.
// A server-ingested Gmail row carries the message id (= version token) where draftId is `r-…`.
export const resolveLoadedDraftVersion = (
  userCommunication: UserCommunication | undefined,
): string | undefined => {
  const draft = userCommunication
    ? (resolveDraftCommunication(userCommunication) as
        | (UserCommunication & DraftVersionField)
        | undefined)
    : undefined;
  if (!draft) {
    return undefined;
  }
  if (draft.draftVersion) {
    return draft.draftVersion;
  }
  return draft.messageId && draft.messageId !== draft.draftId
    ? draft.messageId
    : undefined;
};
